import { render, staticRenderFns } from "./DescargarInformePreventaModal.vue?vue&type=template&id=9c947c02"
import script from "./DescargarInformePreventaModal.vue?vue&type=script&lang=js"
export * from "./DescargarInformePreventaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports